import { Helmet } from 'react-helmet-async';
// sections
import { NewLoSamView } from 'src/sections/losam/view';

// ----------------------------------------------------------------------

export default function LoSamNewPage() {
  return (
    <>
      <Helmet>
        <title> Quản trị: Lô sâm</title>
      </Helmet>

      <NewLoSamView />
    </>
  );
}
